<social-media-widget-svg-sprite />

<div class="social-media-bar" [ngClass]="{
    'horizontal-right-align': socialMediaBar.horizontalPosition === 'right',
    'horizontal-left-align': socialMediaBar.horizontalPosition === 'left',
    'vertical-top-align': socialMediaBar.verticalPosition === 'top',
    'vertical-center-align': socialMediaBar.verticalPosition === 'center',
    'vertical-bottom-align': socialMediaBar.verticalPosition === 'bottom'
  }">

    <ul class="social-media-widgets">

        @for (platform of socialMediaBarPlatforms; track $index) {

        @if (platform.enabled) {
        <li class="widget-list " [ngClass]="[
        socialMediaBar.size === 'small' ? 'icon-box-sm' : '',
        socialMediaBar.size === 'large' ? 'icon-box-lg' : '',
        getPlatformClass(platform.name)
      ]" (click)="sharePlatform(platform)">

            <a>
                <svg class="lg-icon">
                    <use [attr.xlink:href]="'#' + platform.iconName"></use>
                </svg>
                @if (platform.name !== "Settings") {
                <span>
                    Share
                </span>
                }
                @if (platform.name === "Settings") {
                <span>
                    Settings
                </span>
                }
            </a>
        </li>
        }
        }
    </ul>
</div>
